import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Enveloppe des deux écrans de messages : la liste et l'éditeur.
 *
 * Plus de fournisseur à poser ici : les modèles viennent de l'API et vivent
 * dans le cache de react-query, partagé par les deux pages — passer de la
 * liste à l'éditeur ne relance donc aucune requête.
 */
export const Route = createFileRoute('/_app/messages')({
  component: () => <Outlet />,
});
